export default __webpack_public_path__ + "static/media/toinhabrasilshow-camarote.1090f5e0.png";